import * as React from 'react'
import clsx from 'clsx'
import './Avatar.css'

interface Props {
  name: string
  size?: 'sm' | 'md' | 'lg'
  active?: boolean
  /** Force gradient style (used by brand/user avatars). */
  gradient?: boolean
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) {
    const part = parts[0] ?? '?'
    return (part.charAt(0) + (part.charAt(1) || '')).toUpperCase()
  }
  const first = parts[0]?.charAt(0) ?? ''
  const last = parts[parts.length - 1]?.charAt(0) ?? ''
  return (first + last).toUpperCase()
}

export function Avatar({ name, size = 'md', active, gradient }: Props): React.JSX.Element {
  return (
    <span
      className={clsx(
        'avatar',
        `avatar-${size}`,
        active && 'avatar-active',
        gradient && 'avatar-gradient',
      )}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  )
}
